import cx from 'classnames'
import Styles from './ImageThumbnail.module.scss'
import { ImageThumbnailProps } from './Types'
import { useHover } from '@react-aria/interactions'
import { Checkbox } from 'blaze-ui/Checkbox/Checkbox'
import { useEffect, useState } from 'react'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { VideoDuration } from 'components/VideoDuration/VideoDuration'
import { Skeleton } from 'antd'
import { useFlipperFlag } from 'hooks/useFlipperFlag'

export const ImageThumbnail = ({
  image,
  onToggleSelect,
  isSelected,
  label,
  duration,
  isUsed,
  forceLoading = false,
}: ImageThumbnailProps) => {
  const { hoverProps, isHovered } = useHover({})
  const [error, setError] = useState(false)
  const { isMobile } = useResponsiveDesign()
  const [isLoading, setIsLoading] = useState(true)
  const isBrandKitMediaReservationEnabled = useFlipperFlag('brand_kit_media_reservation')
  const isLoadingState = forceLoading || isLoading

  const handleSelect = () => {
    if (error) return
    onToggleSelect?.(image)
  }

  useEffect(() => {
    if (isSelected && error) {
      onToggleSelect?.(image)
    }
  }, [error, isSelected, onToggleSelect, image])

  return (
    <div
      {...hoverProps}
      className={cx(Styles.imageThumbnail, {
        [Styles.hovered]: isHovered,
        [Styles.selected]: isSelected,
        [Styles.errored]: error,
        [Styles.loading]: isLoadingState,
      })}
      onClick={handleSelect}
      data-testid="image-thumbnail"
    >
      {error ? (
        <div className={Styles.error}>Error loading image</div>
      ) : (
        <>
          <img
            alt="preview"
            src={image.url}
            className={Styles.image}
            onError={() => {
              if (forceLoading) return
              setError(true)
            }}
            onLoad={() => setIsLoading(false)}
          />
          {isLoadingState && <Skeleton active paragraph={false} className={Styles.skeleton} />}
          {duration && <VideoDuration duration={duration} />}
        </>
      )}
      {(isSelected || isHovered) && !error && !!onToggleSelect && (
        <div className={Styles.checkbox}>
          <Checkbox
            color="var(--selected-fill)"
            size={isMobile ? 20 : 28}
            isSelected={isSelected}
            aria-label="Select image"
          />
        </div>
      )}
      {label && <p className={Styles.label}>{label}</p>}
      {isBrandKitMediaReservationEnabled && isUsed && <div className={Styles.used}>Used</div>}
    </div>
  )
}
